import {
  atom,
  selectorFamily,
} from 'recoil';

const classesStateType = {
    INIT: "init",
    SUB_MENU: "submenu",
    CREATE_MENU: "create_menu",
};

const classesSubMenuIndex = {
    IN_PROGRESS: "In Progress",
    PUBLISHED: "Published",
    CLASSES: "Classes",
};

const classesStatus = atom({
    key: "classesAtom",
    default: false,
});

const classesSubMenu = atom({
    key: "_classesSubMenu",
    default: "Classes",
});

const classesCreateMenu = atom({
    key: "classesCreateMenu",
    default: "Details",
});

const classesState = selectorFamily({
    key: "CLASSES_STATE",
    set:
        (type) =>
        ({ set }, newValue) => {
            switch (type) {
                case classesStateType.INIT:
                    set(classesStatus, newValue);
                    break;
                case classesStateType.SUB_MENU:
                    set(classesSubMenu, newValue);
                    break;
                case classesStateType.CREATE_MENU:
                    set(classesCreateMenu, newValue);
                    break;
                default:
                    break;
            }
        },
    get:
        (type) =>
        ({ get }) => {
            switch (type) {
                case classesStateType.INIT:
                    return get(classesStatus);
                case classesStateType.SUB_MENU:
                    return get(classesSubMenu);
                case classesStateType.CREATE_MENU:
                    return get(classesCreateMenu);
            }
            return {};
        },
});

export { classesState, classesStateType, classesSubMenuIndex };
